<template>
    <div
        v-if="hasBanners"
        class="banner-carousel"
    >
        <div class="banner-carousel__item-wrapper">
            <CarouselBanner
                class="banner-carousel__item"
                v-bind="activeBanner"
                @click="onClick"
            />
        </div>
        <div class="banner-carousel__navigation">
            <span
                v-if="showNavigator"
                @click="onPreviousBannerClick"
                class="banner-carousel__navigation-control"
            >
                <i class="icon icon-chevron_left"/>
            </span>
            <span
                v-for="(banner, bannerIndex) in banners"
                :key="bannerIndex"
                :class="{'selected': isSelected(bannerIndex)}"
                class="banner-carousel__navigation-item"
                @click="() => selectBanner(bannerIndex)"
            >
                {{ banner.title }}
            </span>
            <span
                class="banner-carousel__navigation-control"
                v-if="showNavigator"
                @click="onNextBannerClick"
            >
                <i class="icon icon-chevron_right"/>
            </span>
        </div>
    </div>
</template>

<script>
    import config from '@config';
    import CarouselBanner from './components/CarouselBanner.vue';
    import BannerContainerMixin from './BannerContainerMixin.ts';

    export default {
        name: 'CarouselBannerContainer',
        mixins: [BannerContainerMixin],
        props: {
            banners: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                index: 0,
                intervalId: null,
            };
        },
        created() {
            this.startPeriodicalChange();
        },
        computed: {
            hasBanners() {
                return !!(this.banners && this.banners.length);
            },
            showNavigator() {
                return this.banners.length > 1;
            },
            activeBanner() {
                return this.banners[this.index];
            },
        },
        methods: {
            onPreviousBannerClick() {
                this.decrementIndex();
                this.resetPeriodicalChange();
            },
            onNextBannerClick() {
                this.incrementIndex();
                this.resetPeriodicalChange();
            },
            selectBanner(index) {
                this.index = index;
                this.resetPeriodicalChange();
            },
            resetPeriodicalChange() {
                clearInterval(this.intervalId);
                this.startPeriodicalChange();
            },
            startPeriodicalChange() {
                // this is needed so banners can be changed periodically
                this.intervalId = setInterval(
                    this.incrementIndex,
                    config.app.country.bannerChangePeriod
                );
            },
            incrementIndex() {
                this.index += 1;
                this.index = this.index % this.banners.length;
            },
            decrementIndex() {
                this.index = Math.max(0, this.index - 1);
            },
            isSelected(bannerIndex) {
                return bannerIndex === this.index;
            },
        },
        components: {
            CarouselBanner,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/banners/CarouselBannerContainer.vue